import { useCallback } from 'react';

import { useClearRefinements, useInstantSearch } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core-react/tracking';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefine: () => void;
	}
>;

export function useClearAllFilters(): Result {
	const { canRefine, refine } = useClearRefinements();
	const { results } = useInstantSearch();

	const track = useTracking();
	return {
		data: {
			hideButton: !canRefine,
		},
		actions: {
			clearRefine: useCallback(() => {
				refine();
				void track('search', { q: results.query || '', context: 'clear_filters_modal_button' });
			}, [refine, results.query, track]),
		},
	};
}
